import { j as u } from "../../jsx-runtime-p91LotPX.mjs";
import { $ as V, A as ye } from "../../main-C3-4ZYQP.mjs";
import { f as we } from "../../immer.esm-DKj4WCmc.mjs";
import { a as Re, b as Oe, t as ge } from "../../table-XsUAem3c.mjs";
import { l as De } from "../../lodash-lyheMOjd.mjs";
import { useState as N, useMemo as d, useCallback as M, useEffect as w, cloneElement as Ee } from "react";
import { CustomLoadingOverlay as Ae } from "../Overlays/LodingOverlay.js";
import { NoRowsOverlay as xe } from "../Overlays/NoRowsOverlay.js";
import { localStore as F, sessionStore as z } from "../utils/browser-storage/index.js";
import Ie from "./BulkAction/BulkActions.js";
import Q from "./ColumnCustom/ColumnSort/ColumnSortDrawer.js";
import { defaultCellComponents as Ne } from "./DefaultCellComponents/index.js";
import { defaultHeaderComponents as Me } from "./DefaultHeaderComponents/index.js";
import { TablePagination as ke } from "./Pagination/TablePagination.js";
import { columnStateTransformer as ve, getSortColumns as k, getCustomColumnParams as v } from "./predicate.js";
import Le from "./style.js";
import { sortingMap as je } from "./type.js";
import { getColumnDSortColDef as Be, getQuickOperationsColDef as Te } from "./util.js";
function et(f) {
  var G;
  const {
    gridProps: t,
    loading: R,
    handlePageChange: O,
    sortMode: L,
    bulkActionComponents: q,
    tablePaginationProps: S,
    tableState: c,
    getUpdatedTableValue: g,
    enableColumnCustom: a,
    quickOperationsColumnProps: D,
    quickOperations: C
  } = f, [l, H] = N(null), [i, W] = N(null), [h, E] = Re(ge), [A, p] = N(!1), $ = h.selectAll.select_all, j = h.selectedRows, s = d(() => V(a).with({
    type: "default"
  }, ({
    content: e
  }) => e).with({
    type: "header-only"
  }, ({
    content: e
  }) => e).otherwise(() => null), [a]);
  function J() {
    if (!(s != null && s.preserve))
      return;
    const {
      type: e
    } = s.preserve;
    if (e === "LOCAL")
      return F.getItem(s.preserve.storageKey);
    if (e === "SESSION")
      return z.getItem(s.preserve.storageKey);
    if (e === "REMOTE")
      return s.preserve.value;
  }
  const r = d(J, [s == null ? void 0 : s.preserve]);
  function B(e) {
    e && (i == null || i.applyColumnState({
      state: ve(e),
      applyOrder: !0
    }));
  }
  const X = M(B, [i]);
  function Y() {
    var e;
    R && !(t != null && t.rowData) ? l == null || l.showLoadingOverlay() : !R && !((e = t == null ? void 0 : t.rowData) != null && e.length) ? l == null || l.showNoRowsOverlay() : l == null || l.hideOverlay();
  }
  function Z(e) {
    var o;
    if ((o = t == null ? void 0 : t.onRowSelected) == null || o.call(t, e), ["rowDataChanged", "api"].includes(e.source)) {
      $ ? e.node.setSelected(!0) : e.node.setSelected(j.map((n) => n.id).includes(String(e.node.id)));
      return;
    }
  }
  function P(e) {
    var K;
    if ((K = t == null ? void 0 : t.onSelectionChanged) == null || K.call(t, e), ["rowDataChanged", "api"].includes(e.source))
      return;
    const o = e.api.getSelectedNodes(), n = o.length, pe = (m) => (m.selectedRows = o.map((y) => ({
      id: String(y.id),
      data: y.data
    })), m.selectAll = {
      select_all: e.source === "apiSelectAll" ? !!n : !1,
      selected: !!n
    }, m);
    if (E((m) => we(m, pe)), c) {
      const m = o.map((U) => ({
        id: String(U.id),
        data: U.data
      })), y = {
        ...c,
        selectedRows: m,
        selectAll: {
          select_all: e.source === "apiSelectAll" ? !!n : !1,
          selected: !!n
        }
      };
      g == null || g(y);
    }
    e.source === "uiSelectAll" && e.api.forEachNode((m) => m.setSelected(!!n));
  }
  function ee(e, o) {
    O == null || O(e, o);
  }
  function te(e) {
    if (L.type === "local")
      return;
    const o = De.head(e.columnApi.getColumnState().filter((n) => !!n.sort));
    o != null && o.sort && L.onSortChange({
      sortCol: o.colId,
      sortOrder: je[o.sort]
    });
  }
  function oe() {
    return {
      ...Me,
      ...Ne,
      ...t.components
    };
  }
  const ne = d(oe, [t.components]);
  w(Y, [l, R, t == null ? void 0 : t.rowData]);
  const x = c ? c.selectedRows : h.selectedRows, le = !!((G = t.rowData) != null && G.length);
  w(() => () => {
    E(Oe);
  }, [E]);
  const T = (a == null ? void 0 : a.type) === "custom" ? Ee(a.customRender, {
    columnApi: i,
    gridApi: l
  }) : null;
  function ae() {
    const e = (a == null ? void 0 : a.type) === "default" || (a == null ? void 0 : a.type) === "header-only", o = (r == null ? void 0 : r.map((n) => n.column)) ?? [];
    if (e) {
      const n = [...t.columnDefs ?? [], {
        ...Be({
          quickOperations: C
        }, D)
      }];
      return r ? k(n, o) : n;
    } else if (!e && C) {
      const n = [...t.columnDefs ?? [], {
        ...Te({
          quickOperations: C
        }, D)
      }];
      return r ? k(n, o) : n;
    } else
      return r ? k(t.columnDefs, o) : t.columnDefs;
  }
  const se = d(ae, [a == null ? void 0 : a.type, t.columnDefs, C, D, r]);
  w(() => {
    x.length ? i == null || i.setColumnsVisible(["QUICK_OPERATIONS", "COLUMN_SORT"], !1) : i == null || i.setColumnsVisible(["QUICK_OPERATIONS", "COLUMN_SORT"], !0);
  }, [i, x.length]);
  function ie() {
    return /* @__PURE__ */ u.jsx(u.Fragment, { children: V(a).with({
      type: "custom"
    }, () => T).with({
      type: "default"
    }, ({
      content: e
    }) => l && /* @__PURE__ */ u.jsx(Q, { api: l, columnApi: i, ...e, defaultState: f.gridProps.columnDefs })).with({
      type: "header-only"
    }, ({
      content: e
    }) => l && /* @__PURE__ */ u.jsx(Q, { api: l, columnApi: i, ...e, defaultState: f.gridProps.columnDefs })).otherwise(() => null) });
  }
  const _ = M(I, [I]), ce = d(ie, [T, i, a, l, f.gridProps.columnDefs]);
  function I(e) {
    s != null && s.preserve && (s.preserve.type === "LOCAL" ? F.setItem(s.preserve.storageKey, e) : s.preserve.type === "SESSION" && z.setItem(s.preserve.storageKey, e));
  }
  function ue(e) {
    var n;
    (n = t == null ? void 0 : t.onColumnMoved) == null || n.call(t, e);
    const o = e.columnApi.getColumnState().map(v);
    e.source || _(o);
  }
  function re(e) {
    var n;
    (n = t == null ? void 0 : t.onColumnResized) == null || n.call(t, e);
    const o = e.columnApi.getColumnState().map(v);
    e.source !== "api" && I(o);
  }
  function me(e) {
    var n;
    (n = t == null ? void 0 : t.onColumnVisible) == null || n.call(t, e);
    const o = e.columnApi.getColumnState().map(v);
    e.source || _(o);
  }
  function fe(e) {
    var o;
    (o = t == null ? void 0 : t.onRowDataUpdated) == null || o.call(t, e), e.api.getDisplayedRowCount() && X(r);
  }
  function de(e) {
    var o;
    H(e.api), W(e.columnApi), (o = t == null ? void 0 : t.onGridReady) == null || o.call(t, e), f.sortMode.defaultSort && e.columnApi.applyColumnState({
      state: f.sortMode.defaultSort
    }), B(r);
  }
  function Se(e) {
    p(e.detail.value);
  }
  const b = M(Se, []);
  w(() => {
    if (l)
      return l.addEventListener("editing", b), () => {
        l.removeEventListener("editing", () => {
          p(!1);
        });
      };
  }, [l, b]);
  function Ce(e) {
    var o;
    (o = t.onCellEditingStarted) == null || o.call(t, e), p(!0);
  }
  function he(e) {
    var o;
    (o = t.onCellEditingStarted) == null || o.call(t, e), p(!1);
  }
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(Ie, { table: c || h, api: l, selectedRows: x, components: q }),
    /* @__PURE__ */ u.jsx(Le, { mask: A || void 0, selection: j.length ? !0 : void 0, className: "ag-theme-alpine", style: {
      overflow: "auto",
      width: "100%",
      height: f.gridProps.domLayout ? "auto" : "inherit"
    }, ...f.variants, children: /* @__PURE__ */ u.jsx(ye, { ...t, maintainColumnOrder: !0, columnDefs: se, onColumnMoved: ue, onColumnResized: re, onColumnVisible: me, onCellEditingStarted: Ce, onCellEditingStopped: he, components: ne, suppressRowClickSelection: !0, suppressCellFocus: !0, onGridReady: de, rowSelection: "multiple", suppressNoRowsOverlay: le, sortingOrder: ["asc", "desc"], loadingOverlayComponent: Ae, noRowsOverlayComponent: xe, onRowSelected: Z, onSelectionChanged: P, onSortChanged: te, onRowDataUpdated: fe, context: {
      ...t.context,
      table: c
    } }) }),
    S != null && S.hide ? null : /* @__PURE__ */ u.jsx(ke, { handlePageChange: ee, tablePaginationProps: {
      ...S,
      total: c == null ? void 0 : c.bulk_records,
      current: c == null ? void 0 : c.currentPage,
      disabled: A
    } }),
    ce
  ] });
}
export {
  et as Table
};
//# sourceMappingURL=Table.js.map
